/* istanbul ignore file */
export const hasError = (state) => state && !!state.error
